import { FeatureFlags } from 'hooks/useStrategy';

type NavigationServiceType = {
  isNew: boolean;
  isBeta: boolean;
  name: string;
  translationId: string;
  to: string;
  featureId?: FeatureFlags;
};

type NavigationLinkType = {
  name: string;
  services: NavigationServiceType[];
};

/**
 * Navigation links found in the mainmenu, to hide an entry behind a feature
 * flag, add `featureId: <flag_name>` to one of the entries.
 */
export const NAVIGATION_LINKS: NavigationLinkType[] = [
  {
    name: 'fleet',
    services: [
      {
        isNew: true,
        isBeta: false,
        name: 'dashboard',
        translationId: 'components.MainMenu.dashboard',
        to: '/fleet/dashboard',
      },
      {
        isNew: false,
        isBeta: false,
        name: 'planner',
        translationId: 'components.MainMenu.planner',
        to: '/fleet/planner',
      },
      {
        isNew: false,
        isBeta: false,
        name: 'vehicles',
        translationId: 'components.MainMenu.vehicles',
        to: '/fleet/vehicles',
      },
      {
        isNew: false,
        isBeta: false,
        name: 'customers',
        translationId: 'components.MainMenu.fleetCustomers',
        to: '/fleet/customers',
      },
      {
        isNew: false,
        isBeta: false,
        name: 'agreements',
        translationId: 'components.MainMenu.fleetAgreements',
        to: '/fleet/agreements',
      },
      {
        isNew: false,
        isBeta: false,
        name: 'valet',
        translationId: 'components.MainMenu.valet',
        to: '/fleet/valet',
      },
      {
        isNew: false,
        isBeta: false,
        name: 'settings',
        translationId: 'components.MainMenu.fleetSettings',
        to: '/fleet/settings',
      },
    ],
  },
];

export const DEFAULT_NAVIGATION_LINK = 'fleet';

export const FLEET_SERVICES = NAVIGATION_LINKS[0].services;
